import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { GenericGet } from '@/_shared/types';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_EXPORT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_EXPORT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_PATH_KEY,
} from '@/swagger/constants/reports-keys';

type RequestGetReportsAssessmentsQuery = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_PATH_KEY
>['request']['query'];

type RequestGetReportsTrainingsQuery = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_PATH_KEY
>['request']['query'];

export const API_GET_REPORTS_ASSESSMENTS = (
  organizationId: string,
  queryParams: RequestGetReportsAssessmentsQuery,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_REPORTS_TRAININGS = (
  organizationId: string,
  queryParams: RequestGetReportsTrainingsQuery,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_REPORT_ASSESSMENT_EXPORT = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_EXPORT_PATH_KEY, {
    organizationId,
  });
};

export const API_GET_REPORT_TRAINING_EXPORT = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_EXPORT_PATH_KEY, {
    organizationId,
  });
};
